import { DefaultTheme } from "styled-components";

import { IconColor } from "./types";

export const resolveColor = (theme: DefaultTheme, c?: IconColor) => {
  switch (c) {
    case "primary":
      return theme.colors.fg.accent;
    case "secondary":
      return theme.colors.fg.secondary;
    case "error":
      // This used to probe `theme.colors.btn && …` for a palette section that has always been
      // there; the fallback to `txt.required` was never reachable.
      return theme.colors.btn.danger;
    case "disabled":
      return theme.colors.txt.label;
    case "action":
      return theme.colors.fg.secondary;
    case "inherit":
    default:
      return "inherit";
  }
};
